import ReactGA from "react-ga4";

const MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID?.trim();

let isInitialized = false;
let hasWarnedAboutMissingId = false;
let lastTrackedPagePath = null;

const hasMeasurementId = () =>
  Boolean(MEASUREMENT_ID) && !MEASUREMENT_ID.startsWith("YOUR_");

const warnAboutMissingId = () => {
  if (!hasWarnedAboutMissingId) {
    console.warn("Google Analytics Measurement ID is missing; analytics is disabled.");
    hasWarnedAboutMissingId = true;
  }
};

export const initGA = () => {
  if (!hasMeasurementId()) {
    warnAboutMissingId();
    return false;
  }

  if (isInitialized) {
    return true;
  }

  // SPA pageviews are sent explicitly by AnalyticsTracker.
  ReactGA.initialize(MEASUREMENT_ID, {
    gtagOptions: { send_page_view: false },
  });
  isInitialized = true;
  return true;
};

export const trackPageView = (path) => {
  if (!hasMeasurementId() || !isInitialized || lastTrackedPagePath === path) {
    return;
  }

  ReactGA.send({
    hitType: "pageview",
    page: path,
  });
  lastTrackedPagePath = path;
};

export const trackEvent = (category, action, label = "", value = 0) => {
  if (!hasMeasurementId() || !isInitialized) {
    return;
  }

  ReactGA.event({
    category,
    action,
    label,
    value,
  });
};
